<div *ngIf="loading" class="row pt-2">
    <div class="col-12 text-center">
        <p class="animate__animated animate__pulse animate__infinite">Refrescando datos 
            <span> <img class="spinner" src="assets/images/loadings/loading1.png" width="20px"></span>
        </p>
    </div>
</div>

